import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import FilterListIcon from '@mui/icons-material/FilterList'
import UpdateIcon from '@mui/icons-material/Update'
import SearchIcon from '@mui/icons-material/Search'
import { NoticeFeedPage, type NoticeFeedConfig } from './NoticeFeedPage'

const cfg: NoticeFeedConfig = {
    typeint: 3,
    showDeadline: true,
    basePath: '/live-pins',
    noun: 'PINs',
    metaTitle: 'Prior Information Notices',
    metaDescription: 'Search live UK & Ireland Prior Information Notices (PINs). Spot upcoming procurements early and engage buyers before the tender is published.',
    keywordMetaDescription: k => `Live ${k} Prior Information Notices across the UK & Ireland public sector. Spot upcoming procurements early and engage buyers before the tender lands with Contract Finder Pro.`,
    heroHighlight: 'Every Live',
    heroRest: 'UK & Ireland Prior Information Notice',
    heroSub: 'PINs signal procurements before they happen. Contract Finder Pro aggregates every UK & Ireland PIN into one searchable feed so you can engage buyers early and prepare before the tender is published',
    searchPlaceholder: 'Search PINs by keyword, buyer or category…',
    listTitleAll: 'All Live PINs',
    featuresTitle: 'Get In Before the Tender',
    features: [
        {
            Icon: NotificationsActiveIcon,
            title: 'Real-Time Publication',
            body: 'PINs appear on CFP within minutes of being published on Find a Tender, Contracts Finder and 200+ additional portals',
        },
        {
            Icon: UpdateIcon,
            title: 'Early Engagement',
            body: 'A PIN can give you months of notice before the tender. Meet the buyer, shape your offer and be ready on day one',
        },
        {
            Icon: FilterListIcon,
            title: 'Powerful Filtering',
            body: 'Filter by buyer, category, CPV code, value and region so the early signals you see are the ones that matter to your business',
        },
        {
            Icon: SearchIcon,
            title: 'Full Text Search',
            body: 'Search across PIN titles, buyers, descriptions and categories to spot upcoming opportunities in your market',
        },
    ],
}

export default function LivePins() {
    return <NoticeFeedPage cfg={cfg} />
}
